export default async function getProfile(endpoint, jwt) {
  /* const endpoint = localStorage.getItem('endpoint') */
  const url = endpoint + "profile";
  const header = {
    Authorization: jwt,
  };
  try {
    const config = { method: "GET", headers: header };
    const response = await fetch(url, config);
    const json = await response.json();

    return json;
  } catch (error) {
    console.log("Error" + error);
  }
}
